import React,{ useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import toast from 'react-hot-toast';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux'

import { useLoginUserMutation } from '../../app/services/auth'
import { selectCurrentUser } from './authSlice';
const LoginComponent = () => {

    const history = useHistory()
    const [state,setState] = useState({
        email : "",
        password : ""
    })

    const [loginUser, { data,isLoading,isSuccess }] = useLoginUserMutation()
    const currentUser = useSelector(selectCurrentUser)

    const _handleOnChange = e => {
        setState({ ...state,[e.target.name] : e.target.value })
    }

    useEffect(() => {

        if(isSuccess && Object.entries(data).length > 0){
            toast.success('Login Successful')
            
           
            history.push('/')   
             
        }

    },[data,isSuccess])

    const _handleLogin = async (e) => {
        try {
            e.preventDefault()
            await loginUser(state).unwrap()
        }
        catch(e){
            if(e.data && e.data.message) {
                toast.error(e.data.message)
            }
            else{
                console.log("Error",e)
                toast.error("Error while login")
            }
        }
    }

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">

                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Sign In</h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form className="space-y-6" onSubmit={_handleLogin} method="POST">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                Email address
                            </label>
                            <div className="mt-1">
                                <input
                                    id="email"
                                    name="email"
                                    onChange={_handleOnChange}
                                    type="email"
                                    autoComplete="email"
                                    required
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                            </div>
                            <p class="mt-2 text-sm text-gray-500" id="email-description">Hint: admin@gmail.com</p>
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                Password
                            </label>
                            <div className="mt-1">
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    onChange={_handleOnChange}
                                    autoComplete="current-password"
                                    required
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                            </div>
                            <p class="mt-2 text-sm text-gray-500" id="email-description">Hint: admin</p>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                                {isLoading ? (<svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>) : null}
                                Sign in
                            </button>
                        </div>
                    </form>

                    {/* <div className="mt-6">
                        <div className="relative">
                       
                            <div className="relative flex justify-center text-sm">

                                <span className="px-2 bg-white text-gray-500">Or <a href=""><Link to="/signup">Signup</Link></a></span>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>)
}

export default LoginComponent